import type { Action, StoreActionApi } from 'react-sweet-state';
import { EXISTING_PROJECT } from '../../../../common/constants/source';
import { INITIAL_STATE } from '../../../../common/constants/state';
import type { State } from '../../../../common/types';

export type ResetProjectDataAction = () => Action<State, void, void>;

export const resetProjectData =
	() =>
	({ setState, getState }: StoreActionApi<State>) => {
		const {
			projectData: { type, key },
			source,
		} = getState();
		setState({
			projectData: {
				...INITIAL_STATE.projectData,
				type,
				...(source === EXISTING_PROJECT && { key }),
			},
		});
	};
